import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import {
    ListCryptoAddressLogRequest, ListCryptoAddressLogResponse,
    ListPaymentsResponse,
    Payment,
    PaymentResult
} from "../http/protocol";


export class PaymentService extends AbstractAdminEntityService<Payment, ListPaymentsResponse>  implements PaymentService {

    constructor(http : HttpService) {
        super("/payments", http)
    }

    async getPaymentById(paymentId: number, includeLog = false){
        let url = `${this.entityPath}/id/${paymentId}?log=${includeLog}`;
        return this.http.get(url);
    }
    
    async getPaymentByUid(paymentUid: string, includeLog = false){
        let url = `${this.entityPath}/uuid/${paymentUid}?log=${includeLog}`;
        return this.http.get(url);
    }

    async getPaymentByExternalPaymentId(externalPaymentId: string, includeLog = false){
        let url = `${this.entityPath}/externalPaymentId/${externalPaymentId}?log=${includeLog}`;
        return this.http.get(url);
    }
    
    async cancelPayment(paymentId: number) { 
        let url = `${this.entityPath}/cancel/${paymentId}`; 
        return this.http.get(url);
    }

    async failPayment(paymentId: number) {
        let url = `${this.entityPath}/fail/${paymentId}`;
        return this.http.post(url, null);
    }

    async approvePayment(paymentId: number):Promise<PaymentResult>  {
        let url = `${this.entityPath}/approve/${paymentId}`;
        return this.http.get(url);
    }

    async resolvePayment(paymentId : number, refund : boolean) {
        let url = `${this.entityPath}/resolve/${paymentId}?refund=${refund}`;
        return this.http.get(url);
    }

    async getCryptoAddresses(request:ListCryptoAddressLogRequest):Promise<ListCryptoAddressLogResponse> {
        return this.http.post<{},{}>(`${this.entityPath}/cryptoaddresses`,
            request) ;
    }
}